import { Injectable } from '@angular/core';
import { UserService} from './user.service';
import { LocationService} from './location.service';
@Injectable()
export class PostService {

user:UserService;
rePostedFrom:any;
modifyDate:number;
text:string;
files:any[];
likes:UserService[];
comments:any[];
reposts:any[];
product: any;
location:LocationService;
hashtags:any[];
$key:string;
rating:any;
userRate;
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/model/post.service.ts